module.exports = __webpack_public_path__ + "img/01.c1d02078.png";